import * as types from '../actions/ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../shared/Assign';
import { merge } from 'lodash';

export function photoOrderListReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.GET_EDITED_PHOTO_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.result
            };
        case types.GET_UNEDITED_PHOTO_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.result.orders,
                photoStatuses: action.result.photoStatuses
            };
        case types.SET_ORDER_AS_ASSIGNED_SUCCESS:
            const newAssignedState = merge({}, state);
            const orderToAssignTO = newAssignedState.orders.filter((x) => x.orderId === action.result.orderId)[0];
            orderToAssignTO.isAssigned = true;
            orderToAssignTO.imageEditorName = action.result.imageEditorName;
            orderToAssignTO.assignedToCurrentUser = action.result.assignedToCurrentUser;

            return newAssignedState;
        case types.SET_ORDER_AS_UNASSIGNED_SUCCESS:
            const newUnassignedState = merge({}, state);
            const orderToUnassignedFrom = newUnassignedState.orders.filter((x) => x.orderId === action.result)[0];
            orderToUnassignedFrom.isAssigned = false;
            orderToUnassignedFrom.assignedToCurrentUser = false;
            return newUnassignedState;
        default:
            return state;
    }
}

export function futurePhotoOrderListReducer(
    state: any = InitialState.futureOrders,
    action: { type: string; result: any }
) {
    let newState = assign([], state);

    switch (action.type) {
        case types.GET_UNEDITED_FUTURE_PHOTO_ORDERS_SUCCESS:
            newState = action.result;
            return newState;
        default:
            return state;
    }
}
